export { useIsTier3Support } from './useIsTier3Support';
